

export default function capHeightFromBbox(bbox: DOMRect, baseline: number): { capHeight: number, descent: number } {
  const descent = bbox.y + bbox.height - baseline
  return { capHeight: bbox.height - 2 * descent, descent };
}